import React from "react";
import { FileText, Download } from "lucide-react";
import { StatusBadge } from "./StatusBadge";
import { formatDate } from "../lib/date";
import { useLocalization } from "../hooks/useLocalization";

export const DocumentViewer = ({ documents = [], onDownload }) => {
  const { t } = useLocalization();

  if (!documents.length) {
    return <p className="text-sm text-gray-500 py-6 text-center" data-testid="documents-empty">{t("common.noData")}</p>;
  }

  return (
    <div className="space-y-2" data-testid="document-list">
      {documents.map((doc) => (
        <div
          key={doc.id}
          className="flex items-center justify-between gap-3 p-3 rounded-lg border border-gray-200 bg-white"
          data-testid={`document-item-${doc.id}`}
        >
          <div className="flex items-center gap-3 min-w-0">
            <FileText className="text-blue-500 shrink-0" size={20} />
            <div className="min-w-0">
              <p className="text-sm font-medium text-gray-800 truncate">{doc.original_filename}</p>
              <p className="text-xs text-gray-500">{doc.category} · {formatDate(doc.created_at)}</p>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <StatusBadge status={doc.status} />
            <button
              data-testid={`download-document-${doc.id}`}
              onClick={() => onDownload(doc)}
              className="p-2 rounded-full hover:bg-blue-50 text-blue-600 transition-colors active:scale-95"
            >
              <Download size={16} />
            </button>
          </div>
        </div>
      ))}
    </div>
  );
};
